var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxException(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#5EAAE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.5L8 4.5M4 4.5L8 8.5",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.64645 4.14645C3.84171 3.95118 4.15829 3.95118 4.35355 4.14645L6 5.79289L7.64645 4.14645C7.84171 3.95118 8.15829 3.95118 8.35355 4.14645C8.54882 4.34171 8.54882 4.65829 8.35355 4.85355L6.70711 6.5L8.35355 8.14645C8.54882 8.34171 8.54882 8.65829 8.35355 8.85355C8.15829 9.04882 7.84171 9.04882 7.64645 8.85355L6 7.20711L4.35355 8.85355C4.15829 9.04882 3.84171 9.04882 3.64645 8.85355C3.45118 8.65829 3.45118 8.34171 3.64645 8.14645L5.29289 6.5L3.64645 4.85355C3.45118 4.65829 3.45118 4.34171 3.64645 4.14645Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxException);
export default __webpack_public_path__ + "static/media/checkbox-exception.e88a955cf439045c77edb95cc1561ec5.svg";
export { ForwardRef as ReactComponent };